export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.user-manager': '用户管理',
  'menu.user-manager.agent': '代理管理',
  'menu.user-manager.partner': '合伙人',
  'menu.user-manager.normal-user': '普通用户',
  'menu.shop-manager': '商城管理',
  'menu.shop-manager.plans': '套餐管理',
  'menu.shop-manager.cards': '卡管理',
  'menu.provider-manager': '运营商管理',
  'menu.provider-manager.provider-list': '运营商列表',
  'menu.provider-manager.cost-list': '结算价格表',
  'menu.orders': '订单管理',
  'menu.finance-manager': '财务管理',
  'menu.finance-manager.recharge-review': '充值审核',
  'menu.finance-manager.withdraw-review': '提现审核',
  'menu.member-system': '会员体系',
  'menu.member-system.activity-manager': '活动管理',
  'menu.system-settings': '系统设置',
  'menu.system-settings.region': '国家地区表',
  'menu.system-settings.sys-log': '操作日志',
  'menu.table-list': '查询表格',
};
